/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.91.2-v202602241958-CDH
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AxiosPromise } from 'axios';
import { getAxiosInstance, SeeqAxiosRequestConfig } from '@/requests/axios.utilities';
import { isNil, omitBy } from 'lodash';
import * as qs from 'qs';
import * as models from '../model/models';
import { APPSERVER_API_PREFIX } from '@/main/app.constants';

export class sqModelsApiClass {
 
   constructor() {}

  /**
   * @summary Apply a model once by providing inputs to the model's features. This endpoint is experimental and may change in future releases.
   * @param {string} modelId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
   */
  public applyModel(
    body: models.OneOffModelApplicationInputV1,
    {
      modelId
    } : {
      modelId: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(modelId)) {
      throw new Error("'modelId' parameter required");
    }

    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/models/${encodeURIComponent(String(modelId))}/instances`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.InstanceOutputV1>;
  }

  /**
   * @summary Apply a model to a table definition. This endpoint is experimental and may change in future releases.
   * @param {string} modelId
   * @param {string} tableDefinitionId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
   */
  public applyModelToTable(
    body: models.TableModelApplicationInputV1,
    {
      modelId,
      tableDefinitionId
    } : {
      modelId: string,
      tableDefinitionId: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(modelId)) {
      throw new Error("'modelId' parameter required");
    }

    if (isNil(tableDefinitionId)) {
      throw new Error("'tableDefinitionId' parameter required");
    }

    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/models/${encodeURIComponent(String(modelId))}/table-application/${encodeURIComponent(String(tableDefinitionId))}`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ModelTableApplicationOutputV1>;
  }

  /**
   * @summary Archive a model by its ID. This endpoint is experimental and may change in future releases.
   * @param {string} id - ID of the model to archive
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
   */
  public archiveModel(
    {
      id
    } : {
      id: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(id)) {
      throw new Error("'id' parameter required");
    }

    return getAxiosInstance()({
      method: 'delete',
      url: APPSERVER_API_PREFIX + `/models/${encodeURIComponent(String(id))}`,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ArchiveOutputV1>;
  }

  /**
   * @summary Create a new model. This endpoint is experimental and may change in future releases.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
   */
  public createModel(
    body: models.ModelV1,
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/models`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ModelV1>;
  }

  /**
   * @summary Create a new model from reference items. This endpoint is experimental and may change in future releases.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
   */
  public createModelFromItems(
    body: models.ModelFromIdsInputV1,
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/models/from-items`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ModelV1>;
  }

  /**
   * @summary Create a new model from reference column definitions. This endpoint is experimental and may change in future releases.
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
   */
  public createModelFromTableColumnDefinitions(
    body: models.ModelFromIdsInputV1,
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/models/from-table-column-definitions`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ModelV1>;
  }

  /**
   * @summary Edit a model by ID. The full model must be provided. This endpoint is experimental and may change in future releases.
   * @param {string} modelId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
   */
  public editModel(
    body: models.ModelV1,
    {
      modelId
    } : {
      modelId: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(modelId)) {
      throw new Error("'modelId' parameter required");
    }

    return getAxiosInstance()({
      method: 'put',
      url: APPSERVER_API_PREFIX + `/models/${encodeURIComponent(String(modelId))}`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ModelOutputV1>;
  }

  /**
   * @summary Generates a list of independent and dependent column definitions from a list of items. The independent column definitions do not rely on other columns, while the dependent column definitions do. This can be used to create a model table from calculations. This endpoint is experimental and may change in future releases.
   * @param {string} scopedTo - The ID of the Workbook that the formula creator column rules will be scoped to
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
   */
  public generateColumnModel(
    body: models.ColumnModelInputV1,
    {
      scopedTo
    } : {
      scopedTo: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(scopedTo)) {
      throw new Error("'scopedTo' parameter required");
    }

    return getAxiosInstance()({
      method: 'post',
      url: APPSERVER_API_PREFIX + `/models/modelData`,
      data: body,

      params: omitBy({
        ['scopedTo']: scopedTo
      }, isNil),
      paramsSerializer: params => qs.stringify(params, { indices: false }),
      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ColumnModelOutput>;
  }

  /**
   * @summary Fetch model instance by ID
   * @param {string} instanceId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
   */
  public getInstance(
    {
      instanceId
    } : {
      instanceId: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(instanceId)) {
      throw new Error("'instanceId' parameter required");
    }

    return getAxiosInstance()({
      method: 'get',
      url: APPSERVER_API_PREFIX + `/models/instances/${encodeURIComponent(String(instanceId))}`,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.InstanceOutputV1>;
  }

  /**
   * @summary Fetch model instances for model ID
   * @param {string} modelId
   * @param {number} [offset=0] - The pagination offset, the index of the first model instance that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of model instances that will be returned in this page of results
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
   */
  public getInstancesForModel(
    {
      modelId,
      offset,
      limit
    } : {
      modelId: string,
      offset?: number,
      limit?: number
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(modelId)) {
      throw new Error("'modelId' parameter required");
    }

    return getAxiosInstance()({
      method: 'get',
      url: APPSERVER_API_PREFIX + `/models/${encodeURIComponent(String(modelId))}/instances`,

      params: omitBy({
        ['offset']: offset,
        ['limit']: limit
      }, isNil),
      paramsSerializer: params => qs.stringify(params, { indices: false }),
      ...extraHttpRequestConfig
      }) as AxiosPromise<models.InstanceOutputPaginatedListV1>;
  }

  /**
   * @summary Fetch model instances for table definition ID
   * @param {string} tableDefinitionId
   * @param {number} [offset=0] - The pagination offset, the index of the first model instance that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of model instances that will be returned in this page of results
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
   */
  public getInstancesForTable(
    {
      tableDefinitionId,
      offset,
      limit
    } : {
      tableDefinitionId: string,
      offset?: number,
      limit?: number
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(tableDefinitionId)) {
      throw new Error("'tableDefinitionId' parameter required");
    }

    return getAxiosInstance()({
      method: 'get',
      url: APPSERVER_API_PREFIX + `/models/instances/table/${encodeURIComponent(String(tableDefinitionId))}`,

      params: omitBy({
        ['offset']: offset,
        ['limit']: limit
      }, isNil),
      paramsSerializer: params => qs.stringify(params, { indices: false }),
      ...extraHttpRequestConfig
      }) as AxiosPromise<models.InstanceOutputPaginatedListV1>;
  }

  /**
   * @summary Fetch a model by ID. This endpoint is experimental and may change in future releases.
   * @param {string} modelId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
   */
  public getModel(
    {
      modelId
    } : {
      modelId: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(modelId)) {
      throw new Error("'modelId' parameter required");
    }

    return getAxiosInstance()({
      method: 'get',
      url: APPSERVER_API_PREFIX + `/models/${encodeURIComponent(String(modelId))}`,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ModelOutputV1>;
  }

  /**
   * @summary Get a list of models. This endpoint is experimental and may change in future releases.
   * @param {number} [offset=0] - The pagination offset, the index of the first item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of models that will be returned in this page of results
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
   */
  public getModels(
    {
      offset,
      limit
    } : {
      offset?: number,
      limit?: number
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    return getAxiosInstance()({
      method: 'get',
      url: APPSERVER_API_PREFIX + `/models`,

      params: omitBy({
        ['offset']: offset,
        ['limit']: limit
      }, isNil),
      paramsSerializer: params => qs.stringify(params, { indices: false }),
      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ModelOutputListV1>;
  }

  /**
   * @summary Reapply a model once by providing inputs to the model's features. This endpoint is experimental and may change in future releases.
   * @param {string} modelId
   * @param {string} instanceId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
   */
  public reapplyModel(
    body: models.OneOffModelApplicationInputV1,
    {
      modelId,
      instanceId
    } : {
      modelId: string,
      instanceId: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(modelId)) {
      throw new Error("'modelId' parameter required");
    }

    if (isNil(instanceId)) {
      throw new Error("'instanceId' parameter required");
    }

    return getAxiosInstance()({
      method: 'put',
      url: APPSERVER_API_PREFIX + `/models/${encodeURIComponent(String(modelId))}/instances/${encodeURIComponent(String(instanceId))}`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.InstanceOutputV1>;
  }

  /**
   * @summary Reapply a model to a table definition. This endpoint is experimental and may change in future releases.
   * @param {string} modelId
   * @param {string} tableDefinitionId
   * @param {string} applicationId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
   */
  public reapplyModelToTable(
    body: models.TableModelApplicationInputV1,
    {
      modelId,
      tableDefinitionId,
      applicationId
    } : {
      modelId: string,
      tableDefinitionId: string,
      applicationId: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(modelId)) {
      throw new Error("'modelId' parameter required");
    }

    if (isNil(tableDefinitionId)) {
      throw new Error("'tableDefinitionId' parameter required");
    }

    if (isNil(applicationId)) {
      throw new Error("'applicationId' parameter required");
    }

    return getAxiosInstance()({
      method: 'put',
      url: APPSERVER_API_PREFIX + `/models/${encodeURIComponent(String(modelId))}/table-application/${encodeURIComponent(String(tableDefinitionId))}/${encodeURIComponent(String(applicationId))}`,
      data: body,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.ModelTableApplicationOutputV1>;
  }

  /**
   * @summary Retire a model table application by ID
   * @param {string} applicationId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
   */
  public retireApplication(
    {
      applicationId
    } : {
      applicationId: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(applicationId)) {
      throw new Error("'applicationId' parameter required");
    }

    return getAxiosInstance()({
      method: 'delete',
      url: APPSERVER_API_PREFIX + `/models/applications/${encodeURIComponent(String(applicationId))}`,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.TableApplicationRetiredOutputV1>;
  }

  /**
   * @summary Retire a model instance by ID
   * @param {string} instanceId
   * @deprecated This API is experimental and may change or be removed in future releases without prior notice.
   */
  public retireInstance(
    {
      instanceId
    } : {
      instanceId: string
    },
    extraHttpRequestConfig?: SeeqAxiosRequestConfig
  ) {
    if (isNil(instanceId)) {
      throw new Error("'instanceId' parameter required");
    }

    return getAxiosInstance()({
      method: 'delete',
      url: APPSERVER_API_PREFIX + `/models/instances/${encodeURIComponent(String(instanceId))}`,

      ...extraHttpRequestConfig
      }) as AxiosPromise<models.InstanceRetiredOutputV1>;
  }

}


export const sqModelsApi = new sqModelsApiClass();
